import { svgIconsTestIds } from '../tests/testIds';

export const LeftArrow = ({ className }: { className?: string }) => (
  <svg
    {...(className && { className })}
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="none"
    data-testid={svgIconsTestIds.leftArrow}
  >
    <path d="M9.9043 17L2.80752 9L9.9043 1" stroke="#060A3D" strokeWidth="3" />
  </svg>
);
